import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HomeIcon from '@material-ui/icons/Home';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { getFromLS, isAdmin, isAuthenticated } from '@orientaction/utils';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import HelpModal from '../Auth/components/HelpModal';
import { RedesignLayout } from '../shared';
import { useErrorPageStyles } from './ErrorPage.styles';

export type ErrorPageProps = {
  code: string;
  title: string;
  description: string;
  showHelp?: boolean;
};

const ErrorPage = ({ code, title, description, showHelp = false }: ErrorPageProps) => {
  const cls = useErrorPageStyles();
  const history = useHistory();
  const isUserConnected = isAuthenticated();
  const user = JSON.parse(getFromLS('userInfos') || '{}');
  const mainLink = !isUserConnected ? '/' : isAdmin(user) ? '/admin/users-resultats' : '/main';
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <RedesignLayout showNav={true} isUserConnected={isUserConnected} noPadding={true}>
      <div className={cls.root}>
        <div className={cls.content}>
          <p className={cls.errorCode}>{code}</p>
          <p className={cls.title}>{title}</p>
          <p className={cls.description}>{description}</p>
          <div className={cls.actions}>
            <button type="button" className={cls.btnPrimary} onClick={() => history.push(mainLink)}>
              <HomeIcon className={cls.btnIcon} />
              Accéder à l&apos;accueil
            </button>
            <button type="button" className={cls.btnSecondary} onClick={() => history.goBack()}>
              <ArrowBackIcon className={cls.btnIcon} />
              Page précédente
            </button>
          </div>
          {showHelp && (
            <button type="button" className={cls.btnHelp} onClick={() => setHelpOpen(true)}>
              <InfoOutlinedIcon className={cls.btnIcon} />
              Besoin d&apos;aide ?
            </button>
          )}
        </div>
      </div>

      {showHelp && (
        <HelpModal
          open={helpOpen}
          onClose={() => setHelpOpen(false)}
          defaultEmail={user?.email || ''}
          defaultName={user?.lastname || ''}
          defaultFirstName={user?.firstname || ''}
        />
      )}
    </RedesignLayout>
  );
};

export default ErrorPage;
